module.exports = __webpack_public_path__ + "img/subBanner7.d916dafa.png";